<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div>
          <h4 class="text-primary">
            Gestión de Entidades
          </h4>
        </div>
      </div>
      <div class="groups col-4 bg-white shadow">
        <vue-context ref="menusecundario" class="mt-5">
          <ul
            class="context-menu-list"
            slot-scope="child"
          >
            <li
              class="context-menu-item title"
              v-bind:style="{ 'background-color': themeConfig.navbarColor + ' !important' }"
            >
              {{ child && child.data ? child.data.name : '' }}
            </li>
            <li
              v-if="child.data && child.data.levelNode > 0"
              class="context-menu-item"
              @click="editSelectedEntity(child.data)"
            >Editar Entidad
            </li>
            <li
              v-if="child.data && child.data.levelNode > 0"
              class="context-menu-item"
              @click="editServicesEntity(child.data)"
            >Servicios Entidad
            </li>
            <li
              v-if="child.data && !child.data.levelNode"
              class="context-menu-item"
              @click="addNewEntityParent()"
            >Nueva Entidad
            </li>
            <li
              v-if="child.data && child.data.levelNode <= maxLevelNode"
              class="context-menu-item"
              @click="addNewEntity(child.data)"
            >
              Nueva Sub-Entidad
            </li>
            <li
              v-if="child.data && child.data.levelNode > 0"
              class="context-menu-item"
              @click="usersOption(child.data)"
            >Usuarios de Entidad
            </li>
            <li
              v-if="child.data && child.data.levelNode > 0"
              class="context-menu-item"
              @click="deleteSelectedEntity(child.data)"
            >Eliminar Entidad
            </li>
          </ul>
        </vue-context>
        <div
          class="demo-inline-spacing"
          v-if="isLoadTree"
        >
          <b-spinner
            key="primary"
            class="mr-1"
            variant="primary"
          />
        </div>
        <TreeItem
          v-if="!isLoadTree"
          class="item"
          :is-open-initial="true"
          :item="treeData"
          @select-item="selectItem"
        >
          <template
            slot="folder-description"
            slot-scope="{item, isOpen}"
          >
            <div @contextmenu.prevent="openContexIfSuperAdmin($event,true, item)">
              <b-icon :icon="isOpen ? 'arrow-down-short' : 'arrow-right-short'"/>
              {{ item.name }}
            </div>
          </template>
          <template
            slot="item-description"
            slot-scope="{item}"
          >
            <ul @contextmenu.prevent="openContexIfSuperAdmin($event,false, item)">
              <li>
                <b-icon :icon="'dash'"/>
                {{ item.name }}
              </li>
            </ul>
          </template>
        </TreeItem>
      </div>
      <div class="col-8 bg-white shadow" id="user-list">
        <h5 class="text-primary">
          Usuarios
        </h5>
        <div class="wrap-table">
          <table
            class="table-users stripe"
            aria-hidden="true"
            v-if="selected"
          >
            <th>Nombre</th>
            <tr :key="indextr" v-for="(user, indextr) in usersOnOption">
              <td>
            <span class="d-flex ml-5">
              <img
                v-if="user.avatar"
                key="onlineImg"
                :src="user.avatar"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer"
              />
              <img
                v-if="!user.avatar"
                key="onlineImg"
                :src="noAvatar"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer"
              />
              <span class="ml-3" style="line-height: 40px;">
                {{ user.name }}
              </span>
            </span>
              </td>
              <td>
                <div class="wrap-actions">
                  <b-dropdown
                    variant="link"
                    no-caret
                    right
                  >
                    <template #button-content>
                      <b-icon
                        class="m-1"
                        variant="danger"
                        icon="trash-fill"
                        @click="deleteOptionUser(user)"
                      />
                    </template>
                  </b-dropdown>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <b-modal
        id="new-folder"
        ref="newfolder"
        title="Nueva Entidad"
        hide-footer
        no-close-on-backdrop
      >
        <div class="row mb-5">
          <div class="col-md-12 mt-3">
            <label>Nombre</label>
            <input
              class="form-control"
              v-model="newitem.name"
            >
          </div>
          <div class="col-md-12 mt-3">
            <div style="float: right">
              <vs-button
                class="action"
                color="primary"
                type="border"
                icon="save"
                @click="isNewParentEntity?saveNewEntityParent():saveNewEntity()"
              >
                Guardar
              </vs-button>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
        size="lg"
        ref="optionUsers"
        hide-footer
        no-close-on-backdrop
        title="Usuarios de la Entidad"
      >
        <users-option
          :usersGeneral="usersGeneral"
          :option="selected"
        />
      </b-modal>
      <b-modal
        size="lg"
        :ref="`entity-edit`"
        hide-footer
        no-close-on-backdrop
        :title="`Editar entidad ${selected.name}`"
      >
        <entity-edit
          :entity="selected"
          @edited="handleOnEdit"
        />
      </b-modal>
      <b-modal
        size="lg"
        :ref="`entity-services-edit`"
        hide-footer
        no-close-on-backdrop
        :title="`Servicios entidad ${selected.name}`"
      >
        <entity-services-edit
          :entity="selected"
          @edited="handleOnServiceEdit"
        />
      </b-modal>
    </div>
  </div>
</template>

<script>
import '@core/scss/base/plugins/extensions/ext-component-context-menu.scss';

import { mapActions, mapGetters } from 'vuex';
import { VueContext } from 'vue-context';
import { uuid } from 'vue-uuid';

import { listV2Options } from '@/febos/servicios/api/opciones.api';
import OptionTreeMixins from '@/febos/global/empresas/componentes/options/OptionTreeMixin';
import themeConfig from '@/../themeConfig';
import TreeItem from '@/components/TreeItem';
import UsersOption from '@/febos/global/materialsRequests/components/UsersOption';
import EntityEdit from '@/febos/global/materialsRequests/vistas/modals/EntityEdit';
import EntityServicesEdit from '@/febos/global/materialsRequests/vistas/modals/EntityServicesEdit';

export default {
  name: 'EntityManagement',
  mixins: [OptionTreeMixins],
  components: {
    TreeItem,
    UsersOption,
    VueContext,
    EntityEdit,
    EntityServicesEdit
  },
  data() {
    return {
      themeConfig,
      isLoadTree: true,
      isSuperAdmin: false,
      search: '',
      tree: {
        name: 'Entidades',
        searchable: true,
        children: []
      },
      newitem: { parameters: [] },
      selectedItem: { parameters: [] },
      isNewParentEntity: false,
      isOpen: true,
      selected: {},
      noAvatar: require('@/assets/images/no-avatar.svg'),
      usersGeneral: [],
      selectedGroup: {},
      usersOnOption: this.optionUsers,
      maxLevelNode: 3
    };
  },
  watch: {
    optionUsers(newValue) {
      this.usersOnOption = newValue;
    },
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#user-list > .con-vs-loading');
        return;
      }

      this.$vs.loading({
        container: '#user-list',
        scale: 0.6
      });
    },
  },
  mounted() {
    this.loadTree();
    this.loadOptionsUsers();
    this.checkIfIsSuperAdmin();
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'usersCompanyAssign'
    ]),
    ...mapGetters('Usuario', ['hasPermission']),
    ...mapGetters('Materials', [
      'optionUsers',
      'loading'
    ]),
    treeData() {
      if (!this.search) {
        return this.tree;
      }
      const word = this.search;
      const newData = JSON.parse(JSON.stringify(this.tree));
      newData.children = this.filterTree(newData.children, word);
      return newData;
    }
  },
  methods: {
    ...mapActions('Empresas', [
      'getUsersCompanyToAssign'
    ]),
    ...mapActions('Materials', [
      'getOptionUsers',
      'getServices',
      'removeOptionUser',
      'setLoading',
      'addEntity',
      'editEntity'
    ]),
    async usersOption(item) {
      this.selected = { ...item };
      this.setLoading({ loading: true });
      await this.getUsersCompanyToAssign({
        empresaId: this.company.id,
        pagina: 1,
        filas: 100000,
        buscarInfoExtra: 'si',
        filtroInfoExtra: 'CARGO'
      });
      this.getOptionUsers({
        grupoOpcion: 'io.solicitud.material.entidades',
        filtros: 'deshabilitado:0',
        id: item.optionId
      });
      this.usersGeneral = this.usersCompanyAssign;
      this.$refs.optionUsers.show();
    },
    checkIfIsSuperAdmin() {
      // TODO CG ver qué permiso se necesita
      this.isSuperAdmin = this.hasPermission('FEB99');
    },
    async loadTree() {
      try {
        this.isLoadTree = true;
        const response = await listV2Options({
          grupoOpcion: 'io.solicitud.material.entidades',
          filtros: 'deshabilitado:0',
        });
        this.tree.children = this.optionToTree(response.data.opciones || []);
      } finally {
        this.isLoadTree = false;
      }
    },
    async loadOptionsUsers(optionId) {
      this.getOptionUsers({
        grupoOpcion: 'io.solicitud.material.entidades',
        filtros: 'deshabilitado:0',
        id: optionId
      });
    },
    async deleteOptionUser(user) {
      try {
        this.removeOptionUser({
          id: user.optionId,
          userId: user.id,
          user
        });
      } finally {
        this.isLoadTree = false;
      }
    },
    addNewEntity(item) {
      this.newitem = {
        parent: item.optionId,
        name: '',
        isFolder: item.levelNode < this.maxLevelNode,
        order: item.children.length + 1
      };
      this.isNewParentEntity = false;
      this.$refs.newfolder.show();
    },
    editSelectedEntity(item) {
      this.selected = { ...item };
      this.getOptionUsers({
        grupoOpcion: 'io.solicitud.material.entidades',
        filtros: 'deshabilitado:0',
        id: item.optionId
      });
      this.$refs['entity-edit'].show();
    },
    editServicesEntity(item) {
      this.selected = { ...item };
      this.$refs['entity-services-edit'].show();
    },
    deleteSelectedEntity(item) {
      this.selectedItem = {
        opcionId: item.optionId,
        padre: item.padre,
        grupoId: item.groupId,
        parametroId: item.parameterId,
        nivel: item.levelNode,
        descripcion: item.name,
        deshabilitado: 1,
        extra: '{"isFolder": '.concat(item.extra.isFolder.toString()).concat('}')
      };
      this.confirmDeleteEntity();
    },
    confirmDeleteEntity() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Atención',
        text: '¿Estás seguro de eliminar la entidad seleccionada?',
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.saveEditEntity()
      });
    },
    addNewEntityParent() {
      this.newitem = {
        parent: '',
        name: '',
        isFolder: true,
        order: ''
      };
      this.isNewParentEntity = true;
      this.$refs.newfolder.show();
    },
    async saveNewEntity() {
      const body = {
        grupoId: 'io.solicitud.material.entidades',
        parametroId: uuid.v4(),
        descripcion: this.newitem.name,
        padre: this.newitem.parent,
        orden: this.newitem.order,
        deshabilitado: 0,
        nivel: 10,
        extra: '{"isFolder": '.concat(this.newitem.isFolder.toString()).concat('}')
      };
      await this.addEntity(body);
      this.$refs.newfolder.hide();
      this.loadTree();
    },
    async saveEditEntity() {
      const body = this.selectedItem;
      await this.editEntity(body);
      this.$refs.editEntity.hide();
      this.loadTree();
    },
    async saveNewEntityParent() {
      const body = {
        grupoId: 'io.solicitud.material.entidades',
        parametroId: uuid.v4(),
        descripcion: this.newitem.name,
        deshabilitado: 0,
        nivel: 10,
        orden: this.treeData.children.length + 1,
        extra: '{"isFolder": true}'
      };
      await this.addEntity(body);
      this.$refs.newfolder.hide();
      this.loadTree();
    },
    selectItem(item) {
      this.selected = item;
      this.loadOptionsUsers(item.optionId);
    },
    openContexIfSuperAdmin(e, isFolder, item) {
      if (this.isSuperAdmin) {
        this.$refs.menusecundario.open(e, item);
      }
    },
    openMenuSecundario(e, item) {
      this.$refs.menusecundario.open(e, item);
    },
    handleOnEdit() {
      this.loadTree();
      this.$refs['entity-edit'].hide();
    },
    handleOnServiceEdit() {
      this.loadTree();
      this.$refs['entity-services-edit'].hide();
    }
  },
};
</script>

<style scoped>
.wrap-actions {
  display: flex;
  justify-content: space-around;
}

.table-users {
  width: 100%;
}

tr:nth-child(even) {
  background-color: #f0f0f0;
}

.wrap-table {
  height: 600px;
  overflow-y: auto;
}
</style>
